import { useState } from 'react';
import config from '../../utils/apiUrl';

const useSendThankYouEmail = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const sendEmail = async (emailData) => {
    console.log(
      'Inicio del envío de correo con los siguientes datos:',
      emailData
    );
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${config.apiUrl}/company/sendThankEmail`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(emailData),
      });
      const data = await response.json();
      if (!data.success) {
        throw new Error('Error al enviar el correo');
      }
    } catch (error) {
      setError(error.message);
      console.error('Error enviando el correo:', error);
    } finally {
      setLoading(false);
    }
  };

  return { sendEmail, loading, error };
};

export default useSendThankYouEmail;
